export default {
  PleaseSelectUser: 'Please select a customer',
  OnlyCrossBorder: 'View only cross-border links',
  CrossBorderLink: 'cross-border link',
  CrossBorderNode: 'Cross-border node',
  NetTips:
    'You can perform quick networking management on a single gateway in the list, and batch modification is supported in graphical mode. \nSpecial reminder: Disabling the networking function may affect the associated policies and cause the policies and configurations to fail. Please operate with caution! If you have any questions, please consult our operation and maintenance engineer before proceeding.',
  DirectPOP: 'Direct POP',
  CPEInformation: 'CPE Information',
  name: 'name',
  model: 'model',
  peerGateway: 'Peer Gateway',
  NetworkDetail: 'Network details',
  nodePlaceholder: 'Click to view CPE and POP information',
  WhetherToUse: 'Whether To Use',
  NoneCpeIPTips: 'Unable to get due to dhcp/pppoe configuration',
  LocalCPE: 'Local CPE',
  DirectlyConnectedNode: 'Directly connected node',
  NodeIp: 'Node IP',
  PeerCPE: 'Peer CPE',
  EnableAllConfirmTitle: 'Make sure to enable the networking function of all branches',
  EnableAllConfirmContent: 'After being turned on, the sdwan service of all network branches will be restored and the branch network connection will be restored.',
  EnableBatchConfirmTitle: (n: number) => `Confirm to enable the networking function of ${n} branches in batches`,
  EnableBatchConfirmContent: 'After being enabled, the branchs sdwan service will be restored and the branch network connection will be restored.',
  EnableSuccess: 'Enable Success',
  DisableAllConfirmTitle: 'Confirm to turn off the user networking function',
  DisableAllConfirmContent: 'After closing, the user SDWAN service will be shut down and all branch network connections will be disconnected. Please confirm the business impact before proceeding.',
  DisableBatchConfirmTitle: (n: number) => `Determine the networking function of batch shutting down ${n} branches`,
  DisableBatchConfirmContent: 'Closing it will cause all connections with other gateways to be disconnected. Please confirm the business impact before proceeding.',
  DisableSuccess: 'Disable Success',
}
